import { useCallback, useEffect, useLayoutEffect, useRef } from 'react';


const useHotKey = (keys, callback, node = null) => {
    const callbackref = useRef(callback);
    useLayoutEffect(()=>{
        callbackref.current = callback;
    });
    const handleKeyPress = useCallback(
        (event) => {
            if (keys.some((key) => event.key === key)){
                callbackref.current(event);
            }
        },
        [keys]
    );

    useEffect(()=>{
        const targetNode = node ?? document;
        targetNode && 
            targetNode.addEventListener("keydown", handleKeyPress);
        return ()=>
            targetNode &&
                targetNode.removeEventListener("keydown",handleKeyPress);
    },[handleKeyPress,node]);
}

export default useHotKey;